module.exports = __webpack_public_path__ + "static/media/logo.1975c5f7.png";